import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { GtmStatsDataPromotionInterface } from '../data/promotion.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';

export class GtmStatsAdapterPromotion implements StatsAdapterInterface {
  /**
   *
   * @param entity
   */
  constructor(protected entity: GtmStatsDataEntityInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataPromotionInterface {
    return {
      id: this.entity.id,
      name: this.entity.name,
      creative: this.entity.dimension6,
      position: this.entity.position,
      list: this.entity.list,
    };
  }
}
